import { Box, Skeleton } from '@mui/material';

export default function LoadingSkeleton() {
    return (
        <Box sx={{ width: '100%' }}>
            <Skeleton variant="rectangular" width="100%" height={42} sx={{ borderRadius: 60, mb: 3.5 }} />
        </Box>
    );
}
